import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=3fa1e693&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=js&"
export * from "./OfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=3fa1e693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa1e693",
  null
  
)

export default component.exports